import { render, staticRenderFns } from "./w-btn.vue?vue&type=template&id=02263e9d&lang=pug&"
import script from "./w-btn.vue?vue&type=script&lang=js&"
export * from "./w-btn.vue?vue&type=script&lang=js&"
import style0 from "./w-btn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02263e9d')) {
      api.createRecord('02263e9d', component.options)
    } else {
      api.reload('02263e9d', component.options)
    }
    module.hot.accept("./w-btn.vue?vue&type=template&id=02263e9d&lang=pug&", function () {
      api.rerender('02263e9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn.vue"
export default component.exports